import { hMacAjax } from 'grt-tool-lib-front';
import ServiceAPI from '@/httpService/serviceApi';
export async function getJumpBusinessParamsApi(data) {
    return hMacAjax.get(ServiceAPI.userCenterAPI + '/open/plan/v1/info',data);
}